import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import AnalyticChartData from "../../../../../api/AnalyticChartData";
import stateAnalyticApp from "../../../../../state/stateAnalyticApp";
import { GraphComponent } from "../GraphComponent";
import { FilterLegend } from "../FilterLegend";
import { RechartsLineBarChart } from "./RechartsLineBarChart";

export const VerifyDatesChart = observer(
  ({ refApp, shiftPress, setScaleGraph, setScaleGraphFlag }) => {
    const [modeLegend, setModeLegend] = useState("index");
    const chartSource = AnalyticChartData.DataSet.SERIALISATION.dates;
    const isLoaded = stateAnalyticApp.loaded_verify_dates;
    const hasData = chartSource.series.length > 0;

    if (isLoaded && !hasData) {
      return null;
    }

    return (
      <GraphComponent
        setScaleGraph={setScaleGraph}
        setScaleGraphFlag={setScaleGraphFlag}
        refApp={refApp}
        shiftPress={shiftPress}
        title="Сериализация (этикетки) по датам"
        flag_loaded={isLoaded}
        id="verifyDates"
      >
        {/* <FilterLegend
          value={modeLegend}
          onChange={(e) => setModeLegend(e.target.value)}
        /> */}
        <RechartsLineBarChart
          chartData={chartSource.chartData}
          series={chartSource.series}
          type="line"
          tooltipShared={modeLegend === "index"}
        />
      </GraphComponent>
    );
  },
);
